import { bubEvents } from 'shared/events/bub_events';

$(document).ready(() => {
  $('.password-reset-form > form').submit((e) => {
    bubEvents.track('Forgot Password', 'Clicked button', {
      label: 'Submit Password Reset',
      value: $('#user_email', e.currentTarget).val(),
    });
  });
});
